<template>
  <div>
    <p v-if="label">{{ label }}</p>

    <v-combobox
      v-model="tags"
      label=""
      :placeholder="$t('components.common.addItem')"
      :hint="$t('components.common.addTagsHint')"
      multiple
      chips
      deletable-chips
      @input="tagsChanged($event)"
      :disabled="disabled"
      item-text="localizedName"
      return-object
    ></v-combobox>
  </div>
</template>

<script>
import { pickLocaleNameWithFallback } from '../../services/locale.service';
import { TagsService } from '../../services/tags.service';
export default {
  props: {
    disabled: false,
    label: '',
  },

  data() {
    return {
      tags: [],
      originalTags: [],
      tagService: new TagsService(),
    };
  },

  methods: {
    setTags(tags) {
      this.originalTags = tags.map((tag) => ({ ...tag, localizedName: pickLocaleNameWithFallback(tag) }));
      this.tags = this.originalTags.slice();
    },

    async tagsChanged($event) {
      let addedTag;
      let removedTag;

      addedTag = await this.tagsAdded();

      if (!!addedTag) {
        this.$emit('add', addedTag);
        return;
      }

      removedTag = this.tagsRemoved();

      if (!!removedTag) {
        this.$emit('remove', removedTag);
      }
    },

    async tagsAdded() {
      let tagsAdded = undefined;

      const newTagsWithoutId = this.tags.filter((tag) => !tag?.id);

      const isTagEqualNewName = (tag, newTagName) =>
        [tag.name?.toLowerCase(), tag.name_eng?.toLowerCase()].includes(newTagName.toLowerCase());

      const isTagInOriginal = (tagName) => this.originalTags.some((orgTag) => isTagEqualNewName(orgTag, tagName));

      if (newTagsWithoutId.length === 0 || newTagsWithoutId.every(isTagInOriginal)) {
        return tagsAdded;
      }

      for (let i = 0; i < newTagsWithoutId.length; i++) {
        const newTagName = newTagsWithoutId[i];
        const tagInDatabase = await this.tagService.findOrCreateTagByName(newTagName);

        if (tagInDatabase.status === 'success') {
          tagsAdded = {
            ...tagInDatabase.data,
            status: 'addedExisting',
            localizedName: pickLocaleNameWithFallback(tagInDatabase.data),
          };

          this.originalTags.push(tagsAdded);
          this.tags = this.originalTags.slice();
        }
      }

      return tagsAdded;
    },

    tagsRemoved() {
      let tagsRemoved = undefined;

      this.originalTags.forEach((orgTag) => {
        const existsIndex = this.tags.indexOf(orgTag);
        if (existsIndex < 0) {
          tagsRemoved = orgTag;
          this.originalTags.splice(this.originalTags.indexOf(orgTag), 1);
        }
      });

      return tagsRemoved;
    },
  },
};
</script>
